import { render, staticRenderFns } from "./membershipWelcome.vue?vue&type=template&id=52958b8b"
import script from "./membershipWelcome.vue?vue&type=script&lang=js"
export * from "./membershipWelcome.vue?vue&type=script&lang=js"
import style0 from "./membershipWelcome.vue?vue&type=style&index=0&id=52958b8b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports